export const faqReducer = (
  state = {
    loading: false,
    data: null,
    singleFaq: null,
    error: null,
  },
  action
) => {
  switch (action.type) {
    // GET_FAQS
    case "GET_FAQS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_FAQS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case "GET_FAQS_FAILURE":
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };

    // GET_FAQ_BY_ID / VIEW_FAQ
    case "GET_FAQ_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        singleFaq: null,
      };

    case "GET_FAQ_SUCCESS":
      return {
        ...state,
        loading: false,
        singleFaq: action.payload?.data || null,
        error: null,
      };

    case "GET_FAQ_FAILURE":
      return {
        ...state,
        loading: false,
        singleFaq: null,
        error: action.payload,
      };

    // ADD_FAQ
    case "ADD_FAQ_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "ADD_FAQ_SUCCESS":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          data: [...(state.data?.data || []), action.payload.data],
        },
        error: null,
      };

    case "ADD_FAQ_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UPDATE_FAQ
    case "UPDATE_FAQ_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "UPDATE_FAQ_SUCCESS":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          data: (state.data?.data || []).map((faq) =>
            faq._id === action.payload.data._id ? action.payload.data : faq
          ),
        },
        singleFaq:
          state.singleFaq?._id === action.payload.data._id
            ? action.payload.data
            : state.singleFaq,
        error: null,
      };

    case "UPDATE_FAQ_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};